/**
 * This will handle the flying banner pre roll
 * @example ng-flying=""
 */

const ngFlying = ['$rootScope', ($rootScope) => {
    return {
        link: function ($scope, $element, $params) {
            let $video = $element[0];

            $video.addEventListener('play', () => {
                $rootScope.$broadcast('flying-play', true);
            });
            // Track errors ( useCapture )
            $video.addEventListener('error', (e) => {
                let networkError = {};
                switch (e.target.networkState) {
                    case e.target.NETWORK_EMPTY:
                        networkError = {
                            code: e.target.networkState,
                            state: 'NETWORK_EMPTY',
                            about: 'HTMLMediaElement has no data yet.',
                        }
                        break;
                    case e.target.NETWORK_IDLE:
                        networkError = {
                            code: e.target.networkState,
                            state: 'NETWORK_IDLE',
                            about: 'HTMLMediaElement is active and has selected a resource, but is not using the network.',
                        }
                        break;
                    case e.target.NETWORK_LOADING:
                        networkError = {
                            code: e.target.networkState,
                            state: 'NETWORK_LOADING',
                            about: 'HTMLMediaElement waiting for the browser to download data.',
                        }
                        break;
                    case e.target.NETWORK_NO_SOURCE:
                        networkError = {
                            code: e.target.networkState,
                            state: 'NETWORK_NO_SOURCE',
                            about: 'HTMLMediaElement src source not found.',
                        }
                        break;
                }
                let mediaError = {};
                switch (e.target.error.code) {
                    case e.target.error.MEDIA_ERR_ABORTED:
                        mediaError = {
                            code: e.target.error.code,
                            state: 'MEDIA_ERR_ABORTED',
                            about: 'You aborted the video playback.',
                            message: e.target.error.message,
                        }
                        break;
                    case e.target.error.MEDIA_ERR_NETWORK:
                        mediaError = {
                            code: e.target.error.code,
                            state: 'MEDIA_ERR_NETWORK',
                            about: 'A network error caused the video download to fail part-way.',
                            message: e.target.error.message,
                        }
                        break;
                    case e.target.error.MEDIA_ERR_DECODE:
                        mediaError = {
                            code: e.target.error.code,
                            state: 'MEDIA_ERR_DECODE',
                            about: 'The video playback was aborted due to a corruption problem or because the video used features your browser did not support.',
                            message: e.target.error.message,
                        }
                        break;
                    case e.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                        mediaError = {
                            code: e.target.error.code,
                            state: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
                            about: 'The video could not be loaded, either because the server or network failed or because the format is not supported.',
                            message: e.target.error.message,
                        }
                        break;
                    default:
                        mediaError = {
                            code: -1,
                            state: 'MEDIA_ERR_UNKNOWN',
                            about: 'An unknown error occurred.',
                        }
                }
                $rootScope.$broadcast('flying-error', {
                    media: mediaError,
                    network: networkError,
                });
            }, true );

            $video.addEventListener('timeupdate', () => {
                // Track middle points
            });

            $video.addEventListener('ended', () => {

            });


        }
    }
}];

export default ngFlying;

